import {
  Box,
  Button,
  Card,
  CardBody,
  Container,
  Heading,
  HStack,
  Icon,
  Image,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import {
  FiBookOpen,
  FiCalendar,
  FiLayers,
  FiSettings,
  FiUsers,
  FiAlertCircle,
  FiPackage,
  FiCompass,
} from 'react-icons/fi'

const sections = [
  {
    title: 'Начало работы',
    description: 'Вход в систему и первые шаги в интерфейсе',
    path: '/getting-started',
    icon: FiBookOpen,
    color: 'blue',
  },
  {
    title: 'График работ',
    description: 'Планирование и контроль рабочих блоков',
    path: '/schedule',
    icon: FiCalendar,
    color: 'purple',
  },
  {
    title: 'Объекты и блоки',
    description: 'Как устроены объекты и как с ними работать',
    path: '/objects-and-blocks',
    icon: FiLayers,
    color: 'orange',
  },
  {
    title: 'Бригады и роли',
    description: 'Кто что видит и кто за что отвечает',
    path: '/users-and-roles',
    icon: FiUsers,
    color: 'teal',
  },
  {
    title: 'Склад',
    description: 'Остатки, резервы, выдача и движения материалов',
    path: '/warehouse',
    icon: FiPackage,
    color: 'cyan',
  },
  {
    title: 'Сценарии по ролям',
    description: 'Пошаговая работа для Наблюдателя, Менеджера и Руководителя',
    path: '/role-scenarios',
    icon: FiCompass,
    color: 'purple',
  },
  {
    title: 'Настройки и отчёты',
    description: 'Работа с параметрами и выгрузкой данных',
    path: '/settings',
    icon: FiSettings,
    color: 'green',
  },
  {
    title: 'Частые вопросы',
    description: 'Что делать, если что-то не работает',
    path: '/troubleshooting',
    icon: FiAlertCircle,
    color: 'red',
  },
]

export const HomePage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={8}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={4}>
            Руководство пользователя FlowTable
          </Heading>
          <Text fontSize="lg" color="gray.600" maxW="4xl">
            Это документация для сотрудников, которые работают в сервисе каждый
            день: планируют задачи, ведут объекты, управляют бригадами и
            формируют отчёты.
          </Text>
        </Box>

        <Card>
          <CardBody>
            <Image
              src="/screenshots/app-login.png"
              alt="Вход в FlowTable"
              borderRadius="lg"
              mb={3}
            />
            <Text fontSize="sm" color="gray.600">
              Начните с раздела «Начало работы», если вы заходите в систему впервые.
            </Text>
          </CardBody>
        </Card>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
          {sections.map((item) => (
            <Card key={item.path}>
              <CardBody>
                <HStack align="start" spacing={4}>
                  <Icon as={item.icon} boxSize={6} color={`${item.color}.500`} />
                  <Box>
                    <Heading as="h3" size="md" mb={2}>
                      {item.title}
                    </Heading>
                    <Text color="gray.600" mb={3}>
                      {item.description}
                    </Text>
                    <Button as={RouterLink} to={item.path} size="sm" variant="outline">
                      Открыть
                    </Button>
                  </Box>
                </HStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>

        <HStack>
          <Button as={RouterLink} to="/getting-started" size="lg">
            Начать работу
          </Button>
        </HStack>
      </VStack>
    </Container>
  )
}
